module.exports = __webpack_public_path__ + "img/simbolo_branco.07209125.png";